import { Col, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import { useRef, useState } from "react";
import downloadImg from '../../../assets/images/Dashboard/downloadImg.svg'

const ViewZoneMasterModal = (props) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const fileInputRef = useRef(null);
    const getSingleZoneMasterData = props.getSingleZoneMasterData;

    // Handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            console.log('Selected file:', file);
        }
    };

    // Trigger file input click when attachment button is clicked
    const handleAttachmentClick = () => {
        fileInputRef.current.click();
    };
    return (
        <>
            <Modal show={props.showViewDetails} onHide={props.handleCloseViewModal} className='add-customer-modal add-user-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>View Zone Master</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Zone Name</label>
                                        <span>{getSingleZoneMasterData[0]?.ZoneName}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Zone Number </label>
                                        <span>{getSingleZoneMasterData[0]?.ZoneNo}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Zone Category</label>
                                        <span>{getSingleZoneMasterData[0]?.CategoryName}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Zone Class</label>
                                        <span>{getSingleZoneMasterData[0]?.ClassName}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Plant Code</label>
                                        <span>{getSingleZoneMasterData[0]?.BranchCode}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Sloc Code</label>
                                        <span>{getSingleZoneMasterData[0]?.SlocCode}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Parent Zone</label>
                                        <span className="description-text">{getSingleZoneMasterData[0]?.ParentZoneName}</span>
                                    </div>
                                    <hr />
                                </Col>
                                <Col md={4}>
                                    <div className="view-sla-data">
                                        <label>Status</label>
                                        <span className="description-text">{getSingleZoneMasterData[0]?.Status}</span>
                                    </div>
                                    <hr />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                </Modal.Body >
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseViewModal} />
                    <SBSaveUpdateBtn btnName="Ok" />
                </Modal.Footer>
            </Modal >
        </>
    );
}

export default ViewZoneMasterModal;